import { BcStateForm } from '@bayclubs/state';

import { CourtEventNoteSaveFormModel } from './../models/court-event-note-save-form.model';

export const COURT_EVENT_NOTE_SAVE_FEATURE_KEY = 'cbCourtEventNoteSave';

export interface CourtEventNoteSaveStateModel {
    form: BcStateForm<CourtEventNoteSaveFormModel>;
}
